import Page from './enrollment-invitations.page.vue'

let routes = [
  {
    path: 'enrollment-invitations',
    name: 'enrollment-invitations',
    component: Page
  },
]

export default routes
